module.exports = "#bgvid{\n    -o-object-fit: cover;\n       object-fit: cover;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    right: 0;\n    bottom: 0;\n    min-width: 100%;\n    min-height: 100%;\n    width: 100%;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n    transform: translateX(-50%) translateY(-50%);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main